import {useAppDispatch} from "@hooks/redux-hooks/hooks";
import React, {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import * as Validation from "@utilities/validationRules";
import * as AuthActions from "@commons/actions/authentication.action";
import {resetPasswordAccount} from "@commons/actions/authentication.action";
import Loading from "../../components/dataTable/Loading";
import Input from "../../components/wrapperComponents/Input";
import Banner, {bannerStyle} from "../../components/Banner";
import FPNetLogo from "../../components/Logo";
import {SignInState} from "./SignInCard3";

interface PasswordDimenticataProps {
    onHandleTornaAllaLogin: () => void;
}

const PasswordDimenticata: React.FC<PasswordDimenticataProps> = ({onHandleTornaAllaLogin}) => {
    const dispatch = useAppDispatch();

    const [status, setStatus] = useState<SignInState>('READY');
    type FormData = {
        id: string | null;
    };
    const {register, handleSubmit, watch, formState: {errors}} = useForm<FormData>({defaultValues: {id: null}});

    function dispatchLogin(data: FormData) {
        setStatus('CHECKING');

        dispatch(resetPasswordAccount({id: data.id!})).then((res) => {
            console.log(res.type);
            if (res.type === AuthActions.resetPasswordAccount.fulfilled.type) {
                setStatus('SUCCESS');
                // @ts-ignore
                setStatusMsg(`E' stata appena inviata un'email con il link per il cambio password all'indirizzo: ${res.payload.email}`)
                console.log('Procedura di reset della password iniziato!');
            } else if (res.type === AuthActions.resetPasswordAccount.rejected.type) {
                setStatus('FAILED');
                // @ts-ignore
                if (res.payload && res.payload.data && res.payload.data.message) { // @ts-ignore
                    setStatusMsg(res.payload.data.message)
                } else
                    setStatusMsg(`Errore generico! Contattare l'assistenza`);
                console.log('Errore in reset password!');
            }
        }, () => {
            // NON CI VIENE MAI!!!
        });
    }

    const id = watch('id');
    useEffect(() => {
        setStatus('READY');
    }, [id])
    const [statusMsg, setStatusMsg] = useState<string>('');

    const loading = status === 'CHECKING';
    const success = status === 'SUCCESS';
    return (
        <>
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
                <FPNetLogo/>
            </div>

            <Loading loading={loading} background={false}>
                <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
                    <div className="bg-white py-8 px-4 shadow rounded-lg sm:px-10">
                        <form className="space-y-6 text-sm" onSubmit={handleSubmit(dispatchLogin)}>
                            <div>
                                <label htmlFor='userName' className="block font-medium">
                                    Per richiedere una nuova password indicare il proprio codice fiscale, username o email
                                </label>
                                <div className="mt-1">
                                    <Input type="text"
                                           name="id"
                                           register={register}
                                           errors={errors}
                                           registerOptions={Validation.required}
                                           placeholder="Codice fiscale, username o email"
                                    />
                                    {errors.id && <p className="text-rose-700">Inserire il codice fiscale, il nome utente o l'indirizzo email.</p>}
                                </div>
                            </div>

                            {status === 'FAILED' && <div className="!mt-4">
                                <Banner className="w-full" style={bannerStyle.xdanger} text={statusMsg}/>
                            </div>}
                            {success && <div className="!mt-4">
                                <Banner className="w-full" style={bannerStyle.success} text={statusMsg}/>
                            </div>
                            }
                            {!success && <div className="!mt-4">
                                <button type="submit"
                                        className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600
                                                    hover:bg-blue-700
                                                    focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500
                                                    disabled:opacity-50"
                                        disabled={loading}>
                                    Richiedi nuova password
                                </button>
                            </div>}
                        </form>

                        <div className="grid grid-cols-1 col-end-1 !mt-2 text-sm">
                            <a href="#" className="font-medium text-blue-600 hover:text-blue-500 text-right"
                               onClick={() => onHandleTornaAllaLogin()}>
                                Torna alla login.
                            </a>
                        </div>
                    </div>
                </div>
            </Loading>
        </>
    )
}
export default PasswordDimenticata;